import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';

import config from '../../config';
import { ToastContainer, notify } from '../../libraries/notifications';
import LayoutSmall from '../../components/layout/LayoutSmall';
import bussinessActions from '../../context/businesses/actions';
import Cover from '../../components/commons/Cover';
import Avatar from '../../components/commons/Avatar';

import Button from '../../components/commons/Button';
import { getObjectWithJsonDataToFormValues } from '../../libraries/utils';

class Pharmacy extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      address: null,
      name: null,
      logo_picture: null,
    }
  }


  componentDidMount() {
    const params = this.props.match.params;
    console.log("MY ORDER", params);
    if (params.id) {
        this.getPharmacy(params.id);
    } else {
        history.push(config.ROUTES.PHARMACIES);
    }
  }

  getPharmacy = async (id) => {
    await this.props.onGetBusiness(id);
    const { business } = this.props;
    console.log('PHARMACY', business, business.error);
    if (business.error) {
        notify(this.t(business.error.message));
    } else {
      const bussinesData = getObjectWithJsonDataToFormValues(
        business.item,
        ['id', "name", "address", "logo_picture", "description", "schedule", 'owner', 'user_id']
      );
      console.log(bussinesData);
      this.setState({ business: bussinesData });
    }
  }

  gotoBack = () => {
    history.push(config.ROUTES.PHARMACIES)
  }


  render() {
    const { business } = this.state;
    console.log(business)
    const { name, address, logo_picture, description, schedule } = business ? business : {};

    return (
      <LayoutSmall
        main={{ className: "bg-base-200" }}
        header={{
            className: "!bg-transparent p-3 fixed",
            left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0" }}
        loading={this.props.business.loading}
      >
        <ToastContainer />
        <Cover image={null} />
        <section className="section-card">
          {name && (
            <>
                <div className="flex flex-col place-items-center p-4">
                  <Avatar
                    image={logo_picture}
                    label=""
                    className="rounded-full w-28 h-28"
                    containerClassName="-mt-16 z-20 border-white border-4 mb-3"
                  />
                  <h1 className="text-primary">{name}</h1>
                  <small className="text-gray-500">{address.direccion}</small>
                </div>
                <div className="py-6 border-t">
                  <h4 className="mb-2">Horario de Atención</h4>
                  {schedule && schedule}
                  {!schedule && <p>{this.t("Esta farmacia no publicó sus horarios")}</p>}
                </div>
                <div className="py-6 border-t">
                  <h4 className="mb-2">Descripción</h4>
                  {description && description}
                  {!description && <p>{this.t("Esta farmacia no cuenta con una descripción")}</p>}
                </div>
            </>
          )}
          <Button
              className="btn-primary btn-block mt-2"
              title={"ENCARGAR EN FARMACIA"}
              onClick={() => {
                  history.push(
                      {
                          pathname: config.ROUTES.PURCHASES.CART,
                          state: {
                              pharmacy:business,
                            }
                      })
              }}
          />
        </section>

      </LayoutSmall>

    )
  }

}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    business: state.businesses.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetBusiness: (params) => dispatch(bussinessActions.get(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Pharmacy));
